import React from 'react';
import PropTypes from 'prop-types';

export default function PuppyCollegeQuote({ title, quote }) {
  return (
    <div className="PuppyCollegeQuote pt30 pb5 pt16-md pb16-md overflow-hidden bg-teal-dark white">
      <div className="container tc-l">
        <p className="font-20 fw-medium mb8">{title}</p>
        <div className="d-block d-md-flex justify-center align-items-center mb4 mb8-lg mb6-sm">
          <p className="font-medium-l f5-lg ph3-lg md:font-40 xs:font-28 font-serif">
            &ldquo;{quote.long_description}&rdquo;
          </p>
        </div>
        <div className="d-flex d-sm-block flex-column">
          <p className="PuppyCollegeQuote__quoteTitle ml4 ml0-md font-16">
            {quote.title}
          </p>
        </div>
      </div>
    </div>
  );
}

PuppyCollegeQuote.propTypes = {
  title: PropTypes.string,
  quote: PropTypes.shape({
    long_description: PropTypes.string,
    title: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    photographs: PropTypes.array
  }).isRequired
};

PuppyCollegeQuote.defaultProps = {
  title: null
};
